@if (open() && releaseNote(); as note) {
<app-modal class="release-note-modal-shell" [showHeader]="false" [showFooter]="false" [ariaLabel]="'shared.releaseNote.title' | translate"
	width="min(56rem, calc(100vw - 2rem))" maxHeight="min(46rem, calc(100dvh - 2rem))" (closed)="close()">
	<section class="release-note-modal" [class.release-note-modal--detail]="detailsOpen()">
		<button type="button" class="release-note-modal__close" [attr.aria-label]="'common.actions.close' | translate" (click)="close()">
			<app-icon icon="fa-solid fa-xmark" color="currentColor" [width]="16" [height]="16" />
		</button>

		@if (!detailsOpen()) {
		<div class="release-note-modal__overview">
			<header class="release-note-modal__header">
				<span class="release-note-modal__badge">{{ 'shared.releaseNote.badge' | translate: { version: note.version } }}</span>
				<h2>{{ 'shared.releaseNote.title' | translate }}</h2>
				<p>{{ 'shared.releaseNote.subtitle' | translate }}</p>
			</header>

			<div class="release-note-modal__body">
				<nav class="release-note-modal__filters" [attr.aria-label]="'shared.releaseNote.filters.ariaLabel' | translate">
					@for (option of filterOptions(); track option.value) {
					<button type="button" [class.release-note-modal__filter--active]="activeFilter() === option.value"
						(click)="selectFilter(option.value)">
						{{ option.label }}
					</button>
					}
				</nav>

				<div class="release-note-modal__cards">
					@for (slide of visibleSlides(); track slide.releaseNoteContentId) {
					<button type="button" class="release-note-card" (click)="openSlide(slide)">
						<span class="release-note-card__icon" [class]="'release-note-card__icon release-note-card__icon--' + categoryTone(slide.releaseNoteContentType)">
							<app-icon [icon]="slide.icon || 'fa-solid fa-star'" color="currentColor" [width]="24" [height]="24" />
						</span>
						<span class="release-note-card__copy">
							<small [class]="'release-note-card__category release-note-card__category--' + categoryTone(slide.releaseNoteContentType)">{{ categoryLabel(slide.releaseNoteContentType) }}</small>
							<strong>{{ slide.title }}</strong>
							<span>{{ slide.description }}</span>
						</span>
						<app-icon icon="fa-solid fa-chevron-right" color="currentColor" [width]="14" [height]="14" />
					</button>
					}
				</div>
			</div>

		</div>
		} @else if (selectedSlide(); as slide) {
		<div class="release-note-modal__detail">
			<aside class="release-note-modal__rail">
				<button type="button" class="release-note-modal__back" (click)="backToOverview()">
					<app-icon icon="fa-solid fa-arrow-left" color="currentColor" [width]="13" [height]="13" /> {{ 'shared.releaseNote.actions.backToOverview' | translate }}
				</button>

				<div class="release-note-modal__rail-heading">
					<h3>{{ 'shared.releaseNote.title' | translate }}</h3>
					<p>{{ note.version }} · {{ formatReleaseDate(note.releaseDate) }}</p>
				</div>

				<div class="release-note-modal__rail-list">
					@for (item of orderedSlides(); track item.releaseNoteContentId) {
					<button type="button" [class.release-note-modal__rail-item--active]="item.releaseNoteContentId === slide.releaseNoteContentId"
						(click)="openSlide(item)">
						<strong [title]="item.title">{{ item.title }}</strong>
					</button>
					}
				</div>
			</aside>

			<article class="release-note-modal__article">
				<div class="release-note-modal__article-layout">
					<span [class]="'release-note-card__icon release-note-card__icon--' + categoryTone(slide.releaseNoteContentType)">
						<app-icon [icon]="slide.icon || 'fa-solid fa-star'" color="currentColor" [width]="20" [height]="20" />
					</span>
					<div class="release-note-modal__article-copy">
						<small [class]="'release-note-card__category release-note-card__category--' + categoryTone(slide.releaseNoteContentType)">{{ categoryLabel(slide.releaseNoteContentType) }}</small>
						<h2 [title]="slide.title">{{ slide.title }}</h2>
					</div>
				</div>
				<p class="release-note-modal__lead">{{ slide.description }}</p>
				<div class="release-note-modal__html" [innerHTML]="safeHtml(slide)"></div>

			</article>
		</div>
		}

		<footer class="release-note-modal__footer">
			<div class="release-note-modal__footer-left">
				@if (note.releaseNoteUrl) {
				<app-button buttonType="secondary" size="sm" postIcon="fa-solid fa-arrow-up-right-from-square"
					[iconWidth]="12" [iconHeight]="12" [horizontalPadding]="true"
					(pressed)="openReleaseNotes(note.releaseNoteUrl)">
					{{ 'shared.releaseNote.link.openReleaseNotes' | translate }}
				</app-button>
				}
			@if (!previewMode()) {
			<label class="release-note-modal__checkbox">
				<input type="checkbox" [ngModel]="doNotShowAgain()" (ngModelChange)="doNotShowAgain.set($event)" />
				<span><strong>{{ 'shared.releaseNote.doNotShowAgain.title' | translate }}</strong><small>{{ 'shared.releaseNote.doNotShowAgain.subtitle' | translate }}</small></span>
			</label>
			}
			</div>

			@if (detailsOpen()) {
			<div class="release-note-modal__nav-actions">
				<app-button buttonType="secondary" size="sm" preIcon="fa-solid fa-chevron-left" iconColor="currentColor" [iconWidth]="12" [iconHeight]="12" [horizontalPadding]="true" [disabled]="!canGoPrevious()" (pressed)="previousSlide()">{{ 'common.actions.previous' | translate }}</app-button>
				<app-button buttonType="primary" size="sm" postIcon="fa-solid fa-chevron-right" iconColor="currentColor" [iconWidth]="12" [iconHeight]="12" [horizontalPadding]="true" [disabled]="!canGoNext()" (pressed)="nextSlide()">{{ 'common.actions.next' | translate }}</app-button>
			</div>
			} @else {
			<app-button buttonType="primary" size="sm" [horizontalPadding]="true" (pressed)="close()">{{ 'shared.releaseNote.actions.understood' | translate }}</app-button>
			}
		</footer>
	</section>
</app-modal>
}
